<ion-note color="danger" *ngIf="hiba" style="display:block;padding:12px">{{ hiba }}</ion-note>

<ng-container *ngIf="ugyirat">
  <ion-card>
    <ion-card-header>
      <ion-card-title>
        {{ ugyirat.iktatoszam }}
        <ion-badge color="danger" *ngIf="ugyirat.ervenytelen">érvénytelen</ion-badge>
      </ion-card-title>
      <ion-card-subtitle>{{ ugyirat.targy }}</ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <div class="ikt-fejsor">
        <ion-badge [color]="ugyirat.allapot === 'folyamatban' ? 'primary' : 'medium'">{{ ugyirat.allapot }}</ion-badge>
        <span><b>Könyv:</b> {{ ugyirat.konyv_nev }}</span>
        <span *ngIf="ugyirat.tetelszam"><b>Irattári tétel:</b> {{ ugyirat.tetelszam }}</span>
        <span *ngIf="ugyirat.megorzes_ev"><b>Megőrzés:</b> {{ ugyirat.megorzes_ev }} év</span>
        <span *ngIf="ugyirat.selejtezheto_ev"><b>Selejtezhető:</b> {{ ugyirat.selejtezheto_ev }}</span>
      </div>

      <div class="ikt-fejsor">
        <ion-input label="Ügyintéző" label-placement="stacked" [(ngModel)]="szerkesztes.ugyintezo"></ion-input>
        <ion-input label="Határidő" label-placement="stacked" type="date" [(ngModel)]="szerkesztes.hatarido"></ion-input>
        <ion-button size="small" (click)="szignal()">Szignálás mentése</ion-button>
      </div>

      <div class="ikt-gombsor">
        <ion-button size="small" (click)="ujAlszam()">
          <ion-icon slot="start" name="add-outline"></ion-icon>Új alszám
        </ion-button>
        <ion-button size="small" fill="outline" (click)="elintez()"
                    *ngIf="ugyirat.allapot === 'folyamatban'">Elintézve</ion-button>
        <ion-button size="small" fill="outline" (click)="irattaraz()"
                    *ngIf="ugyirat.allapot === 'elintezve'">Irattárba</ion-button>
        <ion-button size="small" fill="clear" color="danger" (click)="ervenytelenit('ugyirat', ugyirat.id)"
                    *ngIf="!ugyirat.ervenytelen">Érvénytelenítés</ion-button>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Iratok -->
  <ion-card>
    <ion-card-header><ion-card-title>Iratok ({{ iratok.length }})</ion-card-title></ion-card-header>
    <ion-card-content>
      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead>
            <tr>
              <th>Iktatószám</th><th>Irány</th><th>Tárgy</th><th>Partner</th>
              <th>Hivatkozás</th><th class="szam">Iktatva</th><th>Fájl</th><th>Művelet</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let i of iratok" [class.ervenytelen]="i.ervenytelen">
              <td class="iktszam">{{ i.iktatoszam }}</td>
              <td>
                <ion-badge [color]="i.irany === 'be' ? 'tertiary' : (i.irany === 'ki' ? 'success' : 'medium')">
                  {{ i.irany }}
                </ion-badge>
              </td>
              <td>{{ i.targy }}</td>
              <td>{{ i.partner_nev }}</td>
              <td>{{ i.hivatkozasi_szam }}</td>
              <td class="szam">{{ i.iktatva }}</td>
              <td>
                <ion-badge color="medium" *ngIf="i.melleklet_db">{{ i.melleklet_db }} állomány</ion-badge>
                <ion-badge color="light" *ngIf="i.masolat_hiteles" title="{{ i.masolat_zaradek }}">hiteles másolat</ion-badge>
              </td>
              <td>
                <ion-button size="small" fill="clear" (click)="iratra(i)">Megnyitás</ion-button>
                <ion-button size="small" fill="clear" *ngIf="i.irany === 'ki'" (click)="postara(i)">Postázás</ion-button>
                <ion-button size="small" fill="clear" color="danger" *ngIf="!i.ervenytelen"
                            (click)="ervenytelenit('irat', i.id)">Érvénytelenít</ion-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Napló -->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Eseménynapló</ion-card-title>
      <ion-card-subtitle>Ettől ellenőrizhető utólag az iktatókönyv: ki, mikor, mit tett.</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="ikt-tabla-doboz">
        <table class="ikt-tabla">
          <thead><tr><th class="szam">Mikor</th><th>Ki</th><th>Mit</th><th>Részletek</th></tr></thead>
          <tbody>
            <tr *ngFor="let e of esemenyek">
              <td class="szam">{{ e.mikor | date: 'yyyy. MM. dd. HH:mm' }}</td>
              <td>{{ e.ki || '—' }}</td>
              <td>{{ e.mit }}</td>
              <td style="max-width:420px;overflow-wrap:anywhere">{{ e.reszletek }}</td>
            </tr>
          </tbody>
        </table>
        <div class="ikt-ures" *ngIf="!esemenyek.length">Még nincs naplóbejegyzés.</div>
      </div>
    </ion-card-content>
  </ion-card>
</ng-container>
